export default "__VITE_ASSET__DMP4XmGh__"